import { Button } from "@mui/material";
import { ReactNode } from "react";
import Tooltip from "@mui/material/Tooltip";
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';

interface LinkButtonProps {
    icon: ReactNode;
    onClick: () => void;
    children: ReactNode;
    sx?: object;
    tooltip?: string;
}

const LinkButton = ({ icon, onClick, children, sx, tooltip }: LinkButtonProps) => {
    return (
        <Tooltip title={tooltip || "View Details"} placement="top">
            <Button
                sx={{
                    "& .MuiButton-startIcon svg": {
                        fontSize: "13px !important",
                        color: "#000",
                    },
                    fontSize: "12px",
                    alignItems: "center",
                    ...sx,
                    color: "#0073e6",
                    textDecoration: "none",
                    '&:hover': {
                        textDecoration: "underline",
                        color: "#005bb5"
                    },
                }}
                startIcon={icon}
                endIcon={<OpenInNewOutlinedIcon sx={{ fontSize: "14px !important", ml: -0.5, mb: 0.2 }} />}
                onClick={onClick}
            >
                {children}
            </Button>
        </Tooltip>
    );
};

export default LinkButton;
